const styles = theme => ({
  root: {
    marginTop: 24,
    marginBottom: 42,
    marginLeft: 26,
  },
  group: {

  },
  radioButton: {
    marginBottom: -20,
  },
  button: {
    marginRight: 24,
  },
  buttonNext: {
    marginTop: 32,
  },
  population: {
    marginTop:50,
    marginBottom: 12,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Question4/styles.js